import React, { useEffect, useState } from "react";
import { HashLink } from "react-router-hash-link";
import { Link, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";
import kLogo from "../assets/k_logo_final.png";

export default function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  // Close menu when you change pages
  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname, location.hash]);

  // Stop background scrolling when menu open
  useEffect(() => {
    document.body.style.overflow = menuOpen ? "hidden" : "";
    return () => (document.body.style.overflow = "");
  }, [menuOpen]);

  return (
    <header className="fixed top-0 left-0 right-0 z-50 border-b border-white/10 bg-black/30 backdrop-blur-md">
      <div className="w-full px-4 sm:px-6 md:px-12 lg:px-20 py-4 flex items-center justify-between">
        {/* Logo */}
        <Link to="/" className="flex items-center gap-3 group">
          <img
            src={kLogo}
            alt="Kurukshetra Analytics"
            className="h-8 w-auto transition duration-300 group-hover:scale-110"
          />
          <span className="font-semibold tracking-wide text-white">
            Kurukshetra Analytics
          </span>
        </Link>

        {/* Desktop links */}
        <nav className="hidden md:flex items-center gap-8 text-sm text-white/80">
          <HashLink smooth to="/#showcase" className="hover:text-white transition">
            What we do
          </HashLink>
          <HashLink smooth to="/#insights" className="hover:text-white transition">
            Insights
          </HashLink>
          <Link className="hover:text-white transition" to="/solutions">
            Our Solutions
          </Link>
          <Link className="hover:text-white transition" to="/team">
            Our Team
          </Link>
          <Link className="hover:text-white transition" to="/testimonials">
            Testimonials
          </Link>
          <HashLink smooth to="/#getintouch" className="hover:text-white transition">
            Contact Us
          </HashLink>
        </nav>

        {/* Right side */}
        <div className="flex items-center gap-2">
          {/* WhatsApp button (short on mobile) */}
          <a
            href="https://wa.me/919951186186"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 rounded-2xl px-3 sm:px-4 py-2 text-white hover:opacity-90 border border-white/10 bg-white/5"
            style={{ fontSize: "14px" }}
          >
            <span className="sm:hidden">📞</span>
            <span className="hidden sm:inline">📞 Call / WhatsApp:</span>
            <span className="whitespace-nowrap hidden sm:inline">+91 99511 86186</span>
          </a>

          {/* Hamburger button (mobile only) */}
          <button
            type="button"
            className="md:hidden inline-flex items-center justify-center rounded-2xl p-2 border border-white/10 bg-white/5 hover:bg-white/10"
            onClick={() => setMenuOpen((v) => !v)}
            aria-label={menuOpen ? "Close menu" : "Open menu"}
          >
            {menuOpen ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
          </button>
        </div>
      </div>

      {/* Mobile menu panel */}
      {menuOpen && (
        <div className="md:hidden border-t border-white/10 bg-black/80 backdrop-blur-md">
          <div className="px-4 sm:px-6 py-4 flex flex-col gap-3 text-white/90">
            <HashLink smooth to="/#showcase" className="py-2">What we do</HashLink>
            <HashLink smooth to="/#insights" className="py-2">Insights</HashLink>
            <Link to="/solutions" className="py-2">Our Solutions</Link>
            <Link to="/team" className="py-2">Our Team</Link>
            <Link to="/testimonials" className="py-2">Testimonials</Link>
            <HashLink smooth to="/#getintouch" className="py-2">Contact Us</HashLink>
          </div>
        </div>
      )}
    </header>
  );
}
